import "./App.css";
import Bg from "./Backgrounds/Bg";
import "bootstrap/dist/css/bootstrap.min.css";

function App() {
  return (
    <div>
      <Bg />
    </div>
  );
}

export default App;
